import type { AppProps } from '@boozt/types';
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

const AppContext = createContext<AppProps | undefined>(undefined);

type AppProviderProps = {
    app: AppProps;
    children: ReactNode;
};

export function AppProvider({ app, children }: AppProviderProps) {
    return (
        <AppContext.Provider value={app}>
            {children}
        </AppContext.Provider>
    );
}

export function useApp(): AppProps {
    const context = useContext(AppContext);

    if (context === undefined) {
        throw new Error('useApp must be used within an AppProvider');
    }

    return context;
}
